import {dataMember, required} from 'santee-dcts';
import {EQueryAttachmentBase} from './e-query-attachment-base';

export class EQuerySubmittedResponseAttachment extends EQueryAttachmentBase {

    @dataMember()
    @required()
    public responseId: number;
}